import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { ISalesInvoicesItemsResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoicesItemsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.salesInvoices.items");

const getApis = createGetApi<
  IApiResponse<ISalesInvoicesItemsResponse>,
  IPathByIdParam,
  object
>("stores.salesInvoices.items");

export const items = {
  ...getAllApis,
  ...getApis,
};
